import { api } from './api-client';
import type {
  OnboardingAction,
  OnboardingView,
} from '@logspot-platform/platform-types';

type SuccessEnvelope<T> = { data: T };

export const OnboardingService = {
  get: async (): Promise<OnboardingView> => {
    const result = await api.get<SuccessEnvelope<OnboardingView>>('/onboarding');
    return result.data;
  },

  act: async (action: OnboardingAction): Promise<OnboardingView> => {
    const result = await api.post<SuccessEnvelope<OnboardingView>>(
      '/onboarding',
      action,
    );
    return result.data;
  },
};
